import axios from 'axios';

import { createLotusAxiosConfig } from './client';

export interface SureScriptsMedHistoryItemT {
  displayName: string | null;
  genericDrugName: string | null;
  ndc: string | null;
  rxcui: string | null;
  strength: string | null;
  doseForm: string | null;
  route: string | null;
  directions: string | null;
  quantity: string | null;
  dispenseUnit: string | null;
  daysSupply: number | null;
  refills: string | null;
  noSubstitutions: boolean | null;
  lastFillDate: string | null;
  effectiveDate: string | null;
  writtenDate: string | null;
  expirationDate: string | null;
  payer: string | null;
  drugClassification: string | null;
  diagnosisCode: string | null;
  schedule: number | null;
  pharmacyNotes: string | null;
  pharmacyRxNumber: string | null;
  compoundIngredientSequence: number | null;
  patientMedicationHistoryId: number | null;
  diagnosisQualifier: string | null;
  dispensableDrugId: number | null;
  brand: boolean | null;
  otc: boolean | null;
}

export interface PullMedHistoryResponseT {
  items: SureScriptsMedHistoryItemT[];
  total: number;
  disclaimer: string;
  resultDescription: string | null;
}

export async function pullMedHistory(
  userId: string,
  signal?: AbortSignal
): Promise<PullMedHistoryResponseT> {
  const config = await createLotusAxiosConfig();
  const response = await axios.post<PullMedHistoryResponseT>(
    `/greenfield/care/${userId}/med-history/pull`,
    {},
    { ...config, signal }
  );
  return response.data;
}
